export const isValidSiteName = (value: string) => /^[a-zA-Z0-9-]+$/.test(value);
